import { gql } from '@apollo/client/core';

export const PROVIDER = gql`
  fragment provider on Provider {
    accountNumber
    addressCity
    addressLine1
    addressLine2
    addressState
    addressZipcode
    billingMethod
    certified
    claimRoutingMethod
    claimStatusDate
    claimStatusStatus
    contactEmail
    contactFax
    contactName
    contactPhone
    contactTitle
    dateLastCertified
    dateLastClaim
    dateLastDbUpdate
    dateLastStatement
    dateSetup
    dateTerminate
    degree
    ecsDate
    ecsStatus
    eligibilityDate
    eligibilityStatus
    eraDate
    eraStatus
    feeSchedule
    firstName
    id
    lastName
    lastUpdatedBy
    mailboxId
    mi
    neicId
    neicSiteId
    notes
    nsfBatchNumber
    organizationName
    organizationType
    pcMemory
    pms
    pmsSoftware
    providerGroupId
    recordStatus
    statementDate
    statementMethod
    statementStatus
    submitterNumber
    # account
    # application: Application
    # groupEnrollments: [GroupEnrollment]
    # providerGroup: ProviderGroup
  }
`;

export const getProvidersQuery = gql`
  query GetProviders(
    $first: Int
    $where: ProviderFilterInput
    $order: [ProviderSortInput!]
    $after: String
    $accountName: String
  ) {
    providers(
      first: $first
      where: $where
      order: $order
      after: $after
      accountName: $accountName
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...provider
      }
    }
  }
  ${PROVIDER}
`;

export const getProviderQuery = gql`
  query GetProvider($id: String) {
    provider(id: $id) {
      ...provider
    }
  }
  ${PROVIDER}
`;

export const getProviderBillingsQuery = gql`
  query GetProviderBillings(
    $where: BillingIdsFilterInput
    $first: Int
    $order: [BillingIdsSortInput!]
  ) {
    billingIds(first: $first, where: $where, order: $order) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        billingIdType {
          description
        }
        rowId
        providerGroupId
        providerId
        billingId
        billingIdTypeCode
        status
        name
        dateSetup
      }
    }
  }
`;
